import defaultState, { SessionStatusReducer } from './defaultState'
import { ReduxAction } from '../reducerType'
import { syncType } from '../../actions/sync'
import { roomTypes } from '../../actions/room/roomTypes'
import { setupTypes } from '../../actions/setup/setupTypes'

function addEventLog (eventLog: SessionStatusReducer['eventLog'], event: string): SessionStatusReducer['eventLog'] {

  return [
    ...eventLog, {
      event,
      dstamp: new Date(Date.now()).toISOString()
    }
  ]
    .slice(-10)

}

export default function (state: SessionStatusReducer = defaultState, { type, payload }: ReduxAction): SessionStatusReducer {

  switch (type) {

    case syncType.SYNC_CLIENT_CONNECTED:
      return { ...state, syncClientStatus: 'connected', eventLog: addEventLog(state.eventLog, 'Sync Client connected') }
    case syncType.SYNC_CLIENT_CONNECTING:
      return { ...state, syncClientStatus: 'connecting', eventLog: addEventLog(state.eventLog, 'Sync Client connecting') }
    case syncType.SYNC_CLIENT_DISCONNECTED:
      return { ...state, syncClientStatus: 'disconnected', eventLog: addEventLog(state.eventLog, 'Sync Client disconnected') }
    case roomTypes.TWILIO_RECONNECTING:
      return { ...state, roomStatus: 'reconnecting', eventLog: addEventLog(state.eventLog, 'Room reconnecting') }
    case setupTypes.SET_ROOM: case roomTypes.TWILIO_RECONNECTED:
      return { ...state, roomStatus: 'connected', eventLog: addEventLog(state.eventLog, 'Room connected') }
    case roomTypes.TWILIO_ROOM_DISCONNECTED:
      return { ...state, roomStatus: 'disconnected', eventLog: addEventLog(state.eventLog, 'Room disconnected') }
    default:
      return state

  }

}
